import { ReactComponent as Icon } from "./PlayIcon-thin.svg";

export const PlayIcon = (): JSX.Element => {
  return (
    <Icon className="PlayIcon" />
  );
};
